import { FunctionComponent } from 'react'

import { IconProps } from '@fairhq/common/lib/components/atoms/icons/types'

export const Minus: FunctionComponent<IconProps> = ({
  className,
  fill = 'currentColor',
  width = '24',
  height = '25',
}) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
  >
    <path
      d="M17.2 14.1615C17.918 14.1615 18.5 13.5795 18.5 12.8615C18.5 12.1436 17.918 11.5615 17.2 11.5615H6.8C6.08203 11.5615 5.5 12.1436 5.5 12.8615C5.5 13.5795 6.08203 14.1615 6.8 14.1615H17.2Z"
      fill={fill}
    />
  </svg>
)
